(function ($, Cobalt, undefined) {
    Cobalt.CPNotifications = {
        initialize: function () {

            var $notificationTypes = $(".j-notification-type-display-order");
            var $orderValues = $("#field-order-values");
            if ($notificationTypes.length > 0 && $orderValues.length > 0) {
                $notificationTypes.sortable({
                    stop: function (e, ui) {
                        var orderedValues = [];

                        $(".j-notification-type-display-order > li[data-id]").each(function (i,x) {
                            orderedValues.push($(x).data("id"));
                        });

                        $orderValues.val(orderedValues.join());
                    }
                });
            }
        }
    };

})(jQuery, Cobalt);


// WEBPACK FOOTER //
// ./content/js/Cobalt/Cobalt.CPNotifications.js